import React from "react";
import { ICONS } from "assets/icons";
import "../styles/home.css";

const HomeBanner = ({
  show,
  message,
  actionLabel,
  onAction,
  dismissible,
  onDismiss,
  showNav,
  onPrev,
  onNext,
}) => {
  if (!show) return null;

  return (
    <div className="sticky top-[10px] z-30 w-full px-4 bg-transparent">
      <div className="homeHeader flex items-center justify-between rounded-2xl border border-[var(--surface-border)] bg-gradient-to-r from-[#ffe9e1] via-[#fff6f2] to-[#fef1ff] px-4 py-3 shadow-[0px_18px_38px_-28px_rgba(255,84,62,0.45)]">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <div className="h-9 w-9 shrink-0 rounded-full bg-white text-[#FF543E] shadow-sm grid place-items-center text-lg">
            !
          </div>
          <div className="min-w-0">
            <p className="text-[#FF543E] font-semibold text-sm truncate">
              {message}
            </p>
            <p className="text-[12px] text-[#b24533] opacity-80">
              Stay ahead—resolve quickly to keep delivery high.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          {showNav && (
            <div className="flex items-center gap-1">
              <button
                type="button"
                className="w-8 h-8 rounded-full bg-white text-[#FF543E] flex items-center justify-center shadow-sm hover:-translate-y-0.5 transition"
                onClick={onPrev}
                aria-label="Previous notification"
              >
                ‹
              </button>
              <button
                type="button"
                className="w-8 h-8 rounded-full bg-white text-[#FF543E] flex items-center justify-center shadow-sm hover:-translate-y-0.5 transition"
                onClick={onNext}
                aria-label="Next notification"
              >
                ›
              </button>
            </div>
          )}
          {actionLabel && (
            <button
              className="bg-[#FF543E] text-white text-sm font-semibold py-2 px-3 rounded-full shadow-sm hover:opacity-90 transition"
              type="button"
              onClick={onAction}
            >
              {actionLabel}
            </button>
          )}
          {dismissible && (
            <button
              className="w-8 h-8 rounded-full bg-white text-[#FF543E] grid place-items-center shadow-sm hover:-translate-y-0.5 transition"
              onClick={onDismiss}
              aria-label="Dismiss"
            >
              <img
                className="pointer w-4 h-4"
                src={ICONS.popupX}
                alt="close"
              />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
